import { render, staticRenderFns } from "./Kredit.vue?vue&type=template&id=74058fcf&"
import script from "./Kredit.vue?vue&type=script&lang=js&"
export * from "./Kredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports